import { toast } from "react-toastify";
import { url_creation } from "./DatabaseHelper";

export async function downloadMitarbeiterZip(mitarbeiterId) {
    const id = toast.loading('Zip Datei wird vorbereitet…', { position: 'top-center' });
    try {
      // Baue URL + Header wie in fetchApi, aber hole die Datei als Blob
      const { url, headers } = url_creation('export/mitarbeiter', mitarbeiterId);
      const res = await fetch(url, headers);
      if (!res.ok) throw new Error(`Fehler ${res.status}`);
  
      const blob = await res.blob(); // <— hier Blob statt JSON
      // Datei-Name aus dem Content-Disposition-Header auslesen (optional)
      const cd = res.headers.get('content-disposition') || '';
      const fileNameMatch = cd.match(/filename="?([^"]+)"?/);
      console.log('Content-Disposition Header:', cd);
      console.log('Extrahierter Dateiname:', fileNameMatch);
      const fileName = fileNameMatch ? fileNameMatch[1] : `mitarbeiter_${mitarbeiterId}.zip`;
  
      // Download auslösen
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
  
      toast.update(id, {
        render: `ZIP-File: ${fileName} wird geladen...`,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
    } catch (err) {
      toast.update(id, {
        render: err.message,
        type: 'error',
        isLoading: false,
        autoClose: 5000
      });
    } finally {
      global.emitter.emit("REFRESH_TABLE_DATA");
    }
  }

/**
 * CSV-Download: fetch → Content-Disposition-Filename → Blob → a.click
 * (Geteilter Code für den Export-Dialog und künftige Exporte; kein
 * toast.loading, weil der Dialog selbst den Zustand zeigt)
 */
export async function downloadCsv(apiEndpoint, query) {
    const { url, headers } = url_creation(apiEndpoint, "", query);
    const fullUrl = url + "&limit=ALL&format=csv";

    const res = await fetch(fullUrl, headers);
    if (!res.ok) {
        let detail = `Fehler ${res.status}`;
        try {
            const body = await res.json();
            if (body && body.message) detail = body.message;
        } catch {
            // kein JSON-Body — Status-Text genügt
        }
        throw new Error(detail);
    }

    const blob = await res.blob();
    const cd = res.headers.get("content-disposition") || "";
    const fileNameMatch = cd.match(/filename="?([^"]+)"?/);
    const fileName = fileNameMatch ? fileNameMatch[1] : "daten.csv";

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
    return fileName;
}